import { Console } from 'console';
import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { BreadcrumbService } from '../breadcrumb.service';
import { IUser } from '../shared/Domains/IUser';
import { IPettyExpense } from '../shared/Domains/IPettyExpense'
import { IRole } from '../shared/Domains/role';
import { Router } from '@angular/router';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
    selector: 'app-pettylendingdialog',
    templateUrl: 'petty-lending-dialog.component.html',
    styleUrls: ['petty-lending-dialog.component.css']
})
export class PettyLendingDialogComponent implements OnInit {
    @Input() pettylendingdialogVisibility: boolean;
    @Output() closePettyLendingDialog = new EventEmitter<any>();
    // @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
    user: IUser;
    loading: boolean;
    role: IRole;
    // amount: number;
    // selectedUser: string;
    // purchasedItem: string;
    // billType: string;
    // description: string;
    // paymentMode: string;
    // expenseType: string;
    // paymentOptions = [];
    // pettyExpenseDialogVisibility: boolean;
    pettyExpenses: IPettyExpense[];
    Users: any[];
    isReturned: boolean;
    // userOptions: any[];
    // usersOptions: any[];
    // isDeducted: boolean = false;
    // isReturned: boolean = false;

    constructor(
        private LanguageService: LanguageService,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        public config: Configuration,
        private router: Router,
        private appServiceManager: AppServiceManager,

    ) {
        this.breadcrumbService.setItems([
            { label: 'Petty Cash' }
        ]);
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("PettyCashComponent", label);
    }
    ngOnInit(): void {
        this.user = AuthService.getLoggedInUser();
        // this.amount = 0;
        // this.expenseType = "";
        // this.purchasedItem = "";
        // this.billType = "";
        // this.description = "";

        // this.paymentOptions = [
        //     { label: 'Cash - Reception', value: 'Cash-Reception' },
        // ];
        // this.paymentMode = "Cash-Reception";
        // this.getUserByID();
        // this.getBranch();
        this.getUserPettyExpenses();
        this.role = AuthService.getLoggedInRole();
        // this.getAllUsers();
        // this.userOptions = [{ label: "Select Borrower", value: null }];
        // this.usersOptions = [{ label: "Select Name", value: null }];
    }

    closePettyLendingDialogBefore() {
        this.closePettyLendingDialog.emit();
    }


    getUserByID() {
        this.appServiceManager.get("users/" + this.user._id).subscribe(res => {
            if (res) {
                this.user = res;
                this.Users = res;
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
    }

    // getBranch() {
    //     this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
    //         if (res) {
    //             res.payments.forEach(payment => {
    //                 const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
    //                 if (!existingBank) {
    //                     this.paymentOptions.push({
    //                         label: `${payment.type} - ${payment.name}`,
    //                         value: `${payment.type}-${payment.name}`
    //                     });
    //                 }
    //             });
    //         } else {
    //             this.messageService.clear();
    //             this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
    //         }
    //     },
    //         (error) => {
    //             this.messageService.clear();
    //             this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
    //         });
    // }

    getUserPettyExpenses() {
        this.appServiceManager.get("pettyExpense/" + this.user._id).subscribe(res => {
            if (res) {
                this.pettyExpenses = res.response.filter(r => r.type === "Lending" && r.isReturned === false);
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
    }

    // showAddExpensePopup() {
    //     this.pettyExpenseDialogVisibility = true;
    //     this.amount = 0;
    //     this.expenseType = "";
    //     this.purchasedItem = "";
    //     this.billType = "";
    //     this.description = "";
    // }

    // onPaymentModeChange(value: string) {
    //     this.paymentMode = value;
    // }

    // dropdownChange(e) {
    //     console.log(e);
    //     this.selectedUser = e.value;
    // }

    updatePettyExpense(id) {
        const expense = {};
        this.appServiceManager.post("pettyexpense/"+id+"/lendingReturned", expense).subscribe(res => {
            if (res) {
                this.closePettyLendingDialogBefore();
                this.messageService.clear();
                this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Expenses Updated Successfully' });
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
            }
        },
            (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
    }

    getDetailOfExpance(expance) {
        if (expance.type === "Lending" && expance.borrowerName !== undefined) {
            return "Amount Lend: " + expance.borrowerName;
        }
        else if (expance.type === "Account Deducted" && expance.accountHolderName !== undefined) {
            return "Amount Lend: " + expance.accountHolderName;
        }


        else {
            return "";
        }
    }
    //   getAllUsers() {
    //     this.Users = [];
    //     this.loading = true;
    //     this.appServiceManager.get('users/company/' + this.user.company + '/branch/' + this.user.branch).subscribe(
    //       (res) => {
    //         if (res.length > 0) {
    //           this.Users = res;
    //           this.setUserData(this.Users);
    //           console.log("All Users", this.Users);

    //         } else {
    //           this.Users = [];
    //           this.messageService.clear();
    //           this.messageService.add({
    //             severity: "info",
    //             summary: "Info Message",
    //             detail: "No Record Found",
    //           });
    //         }
    //         this.loading = false;
    //       },
    //       (error) => {
    //         this.loading = false;
    //         this.messageService.clear();
    //         this.messageService.add({
    //           severity: "error",
    //           summary: "Error Message",
    //           detail: error,
    //         });
    //       }
    //     );
    //   }

    //   setUserData(Users) {

    //     this.Users.forEach((Users) => {
    //         this.userOptions.push({
    //             label: Users.name,
    //             value: Users._id,
    //         });
    //         this.usersOptions.push({
    //           label: Users.name,
    //           value: Users._id,
    //       });
    //     });
    // }

}
